function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#75C345"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.707 12.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l6-6a1 1 0 00-1.414-1.414L10 13.586l-1.293-1.293z",
  fill: "#fff"
});

function SvgCheckCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiM3NUMzNDUiLz4KPHBhdGggZD0iTTguNzA3MTEgMTIuMjkyOUM4LjMxNjU4IDExLjkwMjQgNy42ODM0MiAxMS45MDI0IDcuMjkyODkgMTIuMjkyOUM2LjkwMjM3IDEyLjY4MzQgNi45MDIzNyAxMy4zMTY2IDcuMjkyODkgMTMuNzA3MUw5LjI5Mjg5IDE1LjcwNzFDOS42ODM0MiAxNi4wOTc2IDEwLjMxNjYgMTYuMDk3NiAxMC43MDcxIDE1LjcwNzFMMTYuNzA3MSA5LjcwNzExQzE3LjA5NzYgOS4zMTY1OCAxNy4wOTc2IDguNjgzNDIgMTYuNzA3MSA4LjI5Mjg5QzE2LjMxNjYgNy45MDIzNyAxNS42ODM0IDcuOTAyMzcgMTUuMjkyOSA4LjI5Mjg5TDEwIDEzLjU4NThMOC43MDcxMSAxMi4yOTI5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgCheckCircle24 as ReactComponent };